import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20female%20entertainer%20performing%20on%20a%20grand%20stage%2C%20dramatic%20warm%20golden%20spotlight%20from%20above%2C%20graceful%20artistic%20pose%2C%20dreamy%20atmosphere%20with%20floating%20light%20particles%20and%20soft%20haze%2C%20professional%20concert%20photography%2C%20shallow%20depth%20of%20field%20with%20beautiful%20bokeh%2C%20warm%20rose%20gold%20and%20amber%20tones%2C%20sophisticated%20theatrical%20lighting%2C%20ethereal%20and%20cinematic%20quality&width=1600&height=900&seq=hero-yuika-main&orientation=landscape"
        alt="小野坂唯香 舞台表演"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <p className="text-white/80 text-sm md:text-base font-label tracking-widest mb-4 animate-fade-in">
            ONOSAKA YUIKA OFFICIAL FAN SITE
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
            小野坂 <span className="text-primary-400">唯香</span>
          </h1>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-8 max-w-xl mx-auto">
            从练习生到闪耀新星，用歌声与演技打动万千心灵。这里汇聚关于她的一切——<br className="hidden md:block" />个人资料、代表作品、最新动态，一站掌握。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/profile"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-user-heart-line mr-2"></i>了解唯香
            </Link>
            <Link
              to="/category/news"
              className="px-8 py-3 rounded-full border border-white/40 text-white font-medium text-sm whitespace-nowrap hover:bg-white/10 transition-colors"
            >
              <i className="ri-flashlight-line mr-2"></i>最新动态
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}